import { Row, Col, Spinner, Alert } from "react-bootstrap";
import { useInfluencerBonus } from "./hooks/use-Influencer-bonus";
import TotalEarnedCard from "./components/TotalEarnedCard";
import PointsAccumulatedCard from "./components/PointsAccumulatedCard";
import InfluencerSettlementsTable from "./components/InfluencerSettlementsTable";
import BonusStatusCard from "./components/BonusStatusCard";

const BonusInfluencer = () => {

    const {
        activeCurrencies,
        startDate,
        endDate,
        progressPercentage,
        daysRemaining,
        isCurrentWeek,
        isLoading,
        error,
        refetch,
        influencerBonusEnabled
    } = useInfluencerBonus();

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </Spinner>
            </div>
        );
    }

    if (error) {
        return (
            <Alert variant="danger" className="mb-4">
                <Alert.Heading>Error al cargar datos</Alert.Heading>
                <p>{error.message}</p>
                <button
                    className="btn btn-outline-danger"
                    onClick={() => refetch()}
                >
                    Reintentar
                </button>
            </Alert>
        );
    }

    // Show activation prompt if influencer bonus is not enabled
    if (!influencerBonusEnabled) {
        return (
            <div className="text-center py-5">
                <div className="mb-4">
                    <img
                        src="/images/shape-16.png"
                        className="mb-4"
                        alt="Activate bonus"
                        width={200}
                        height={200}
                        style={{ opacity: 0.8 }}
                    />
                </div>

                <h3 className="fs-24 mb-3 text-primary">
                    ¡Activa tu Bono de Influencer!
                </h3>

                <p className="mb-4 text-muted px-3">
                    Para comenzar a ganar bonos como influencer, necesitas realizar una compra
                    y activar tu red de referidos.
                </p>

                <div className="d-flex justify-content-center gap-3">
                    <a href="/store" className="btn btn-primary py-2 px-4 fs-16 fw-medium">
                        <span className="d-inline-block py-1">Explorar Productos</span>
                    </a>
                    <a href="/team" className="btn btn-outline-primary py-2 px-4 fs-16 fw-medium">
                        <span className="d-inline-block py-1">Mi Red</span>
                    </a>
                </div>

                <div className="mt-4 p-3 bg-primary rounded">
                    <small className="text-muted">
                        💡 <strong>Tip:</strong> Una vez que realices una compra,
                        podrás comenzar a ganar bonos por las compras de tus referidos.
                    </small>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* Bonus Status Cards */}
            <Row className="mb-4">
                <Col md={4}>
                    <BonusStatusCard
                        activeCurrencies={activeCurrencies}
                        bonusStatus={influencerBonusEnabled ? "active" : "inactive"}
                        startDate={startDate}
                        endDate={endDate}
                    />
                </Col>
                <Col md={4}>
                    <PointsAccumulatedCard
                        progressPercentage={progressPercentage}
                        startDate={startDate}
                        endDate={endDate}
                        daysRemaining={daysRemaining}
                        isCurrentWeek={isCurrentWeek}
                    />
                </Col>
                <Col md={4}>
                    <TotalEarnedCard
                        activeCurrencies={activeCurrencies}
                    />
                </Col>
            </Row>

            {/* Settlements History Table */}
            <InfluencerSettlementsTable />
        </>
    );
};

export default BonusInfluencer;
